export const validation = {
  headingMaxChar: 20,
  paragraphMaxChar: 500,
  title: { required: true }
}
